import React, { useEffect } from 'react'
import Button from '../components/Button'
import RadioButtonQuestion from '../components/RadioButtonQuestion'
import {questions} from '../data/json'


const TestQuestions5 = ({prevStep, nextStep, handleChange, values}) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])

  const Continue = e => {
    e.preventDefault();
    nextStep();
  }

  const GoBack = e => {
    e.preventDefault(); 
    prevStep();
  }

  return (
    <div className='__test-questions'>
      <h2>Ressourcer og viden</h2>
      <p>Effektiv ressourcestyring er afgørende for at opbygge modstandsdygtighed og derved sikre tilstrækkelige midler til at håndtere udfordringer og kriser. Ved strategisk ressourcestyring kan I sikre nødvendige midler til centrale forretningsområder og projekter, selv under uforudsete omstændigheder. Ekstern videnindsamling og opdatering om markedstendenser forbereder jer bedre på forandringer. Intern vidensdeling undgår fejl, muliggør læring og skaber en lærende organisation, der konstant tilpasser sig og styrker modstandsdygtigheden over for fremtidige udfordringer. </p>
        <form>
          <RadioButtonQuestion isChecked={values.qst5_1} title={questions.resources.qst_1} name="qst-resources_1" value={values} onChange={handleChange('qst5_1')}/>
          <RadioButtonQuestion isChecked={values.qst5_2} title={questions.resources.qst_2} name="qst-resources_2" value={values} onChange={handleChange('qst5_2')}/>
          <RadioButtonQuestion isChecked={values.qst5_3} title={questions.resources.qst_3} name="qst-resources_3" value={values} onChange={handleChange('qst5_3')}/>
          <RadioButtonQuestion isChecked={values.qst5_4} title={questions.resources.qst_4} name="qst-resources_4" value={values} onChange={handleChange('qst5_4')}/>
          <RadioButtonQuestion isChecked={values.qst5_5} title={questions.resources.qst_5} name="qst-resources_5" value={values} onChange={handleChange('qst5_5')}/>
          <div className='__prev-next-buttons'>
            <Button buttonText='Tilbage' onClick={GoBack} />
            <Button buttonText='Næste' onClick={Continue} disabled={(values.qst5_1 !== '' && values.qst5_2 !== '' && values.qst5_3 !== '' && values.qst5_4 !== '' && values.qst5_5 !== '' ) ? false : true} />
          </div>
        </form>
    </div>

  )
}

export default TestQuestions5